export default function AutoImgWidthSrc() {

  var envDPR          = window.devicePixelRatio;
  var vpWidth         = window.innerWidth;
  var imageContainers = document.querySelectorAll('.js-auto-img-width-src');

  if (imageContainers.length) {

    // For each instance...
    Array.prototype.forEach.call(imageContainers, function(el) {

      // Gather all *potential* image paths, as variables.
      var imgPath600  = el.dataset.imgSix;
      var imgPath1200 = el.dataset.imgTwelve;
      var imgPath1800 = el.dataset.imgEighteen;
      var imgPath2400 = el.dataset.imgTwentyFour;
      var imgPath3600 = el.dataset.imgThirtySix;

      var useSource = null;

      // Determine which of them is appropriate.
      if (envDPR >= 1.5) {
        if (vpWidth <= 600) {
          useSource = imgPath1200;
        } else if (vpWidth >= 601 && vpWidth <= 1200) {
          useSource = imgPath2400;
        } else {
          useSource = imgPath3600;
        }
      } else {
        if (vpWidth <= 600) {
          useSource = imgPath600;
        } else if (vpWidth >= 601 && vpWidth <= 1200) {
          useSource = imgPath1200
        } else if (vpWidth >= 1201 && vpWidth <= 1800) {
          useSource = imgPath1800;
        } else if (vpWidth >= 1801 && vpWidth <= 2400) {
          useSource = imgPath2400;
        } else {
          useSource = imgPath3600;
        }
      }

      // Set the appropriate one as the element's background.
      el.style.backgroundImage = 'url(' + useSource + ')';

    });

  }

};
